import React, { useEffect, useState } from "react";
import "./forms.scss";
import PatientInfo1 from "./PatientInfo1";
import ShapeCreation from "./ShapeCreation";
import FoamCarving from "./FoamCarving";
import Submit from "../pages/submit/Submit";
import TfMeasurement from "../pages/patientMeasurement/TfMeasurement";
import BilateralStepper from "../components/stepper/BilateralStepper";
import { OrderTickIcon } from "../icons/svg";
import TtMeasurement from "../pages/patientMeasurement/TtMeasurement";
import TFDefinitiveMeasurement from "../pages/patientMeasurement/TFDefinitiveMeasurement";
import TTOneMeasure from "../pages/patientMeasurement/TTOneMeasure";
import TFOneSocketMeasure from "../pages/patientMeasurement/TFOneSocketMeasure";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import BilateralOrderReview from "./BilateralOrderReview";

const Bilateral = ({ url, split, formId }) => {
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [defaultComponent, setDefaultComponent] = useState();
  const [currentComponent, setCurrentComponent] = useState();
  const [currentFormIndex, setCurrentFormIndex] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isBack, setIsBack] = useState(false);

  const tempArray = [];
  let currentIndex = 0;

  useEffect(() => {
    tempArray.push(
      elements?.find(
        (item) => item.url === url.replace(process.env.REACT_APP_ORDER_FORM, "")
      )
    );
    tempArray.push(elements?.find((item) => item.id === split));
    tempArray.push(userInformation);

    setDefaultComponent([...tempArray]);
    setCurrentComponent(tempArray[0]);
  }, [url, split]);

  useEffect(() => {
    if (isCompleted) {
      setActiveOuterStep(0);
      const tempComponent = defaultComponent[currentFormIndex + 1];
      setCurrentComponent(tempComponent);
      setCurrentFormIndex(currentFormIndex + 1);
      setIsCompleted(false);
    } else if (isBack && currentFormIndex > 0) {
      setCurrentComponent(defaultComponent?.[currentFormIndex - 1]);
      setActiveOuterStep(
        defaultComponent?.[currentFormIndex - 1]?.formData?.length - 1
      );
      setCurrentFormIndex(currentFormIndex - 1);
      setIsBack(false);
    }
  }, [isCompleted, isBack, currentFormIndex, defaultComponent]);

  const handleNext = (step) => {
    if (step === tempArray[currentIndex].formData?.length) {
      currentIndex = currentIndex + 1;
      setIsCompleted(true);
    } else {
      setActiveOuterStep(step);
      setActiveInnerStep(0);
    }
  };

  const handleBack = (step) => {
    if (step === 0) {
      if (currentIndex > 0) {
        currentIndex = currentIndex - 1;
        setIsBack(true);
      }
      return;
    } else {
      setActiveOuterStep(step - 1);
      setActiveInnerStep(0);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const userInformation = {
    name: "Order Information",
    formData: [
      {
        id: 4,
        name: "Customer information",
        innerSteps: [],
        formContent: (
          <ClinicInfo
            formTypeId={formId}
            currentIndex={1}
            setIsBack={setIsBack}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        ),
      },

      {
        id: 5,
        name: "Shipping Information",
        innerSteps: [],
        formContent: (
          <PatientInfo2
            formTypeId={formId}
            currentIndex={2}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        ),
      },

      {
        id: 6,
        name: "Order Review",
        innerSteps: [],
        formContent: (
          <BilateralOrderReview
            forms={tempArray}
            handleNext={handleNext}
            handleBack={handleBack}
            currentIndex={3}
          />
        ),
      },

      {
        id: 7,
        name: "Submit",
        innerSteps: [],
        formContent: <Submit />,
      },
    ],
  };
  const elements = [
    {
      id: "3",
      url: "/ttchecksocket",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={3}
              setIsBack={setIsBack}
              currentIndex={1}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 2,
          name: "Patient Measurement",
          innerSteps: [
            { id: 1, name: "Shape Creation", isActive: true },
            { id: 2, name: "Socket Style", isActive: true },
            { id: 3, name: "Trimline", isActive: true },
            { id: 4, name: "Modification", isActive: true },
            { id: 5, name: "Angles", isActive: true },
            { id: 6, name: "Measurement Notes", isActive: true },
          ],
          formContent: (
            <ShapeCreation
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={3}
              currentIndex={2}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 3,
          name: "Product Information",
          innerSteps: [
            { id: 1, name: "Foam Carving", isActive: true },
            { id: 2, name: "Socket Material", isActive: true },
            { id: 3, name: "Suspension", isActive: true },
            { id: 4, name: "Mounting Plate", isActive: true },
            { id: 5, name: "Insert Material", isActive: true },
            { id: 6, name: "Delivery Date", isActive: true },
            { id: 7, name: "Notes", isActive: true },
          ],
          formContent: (
            <FoamCarving
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={3}
              currentIndex={3}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },
      ],
      name: "TT Check Socket",
    },

    {
      id: "4",
      url: "/tfcheksocket",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={4}
              currentIndex={1}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 2,
          name: "Patient Measurement",
          innerSteps: [
            { id: 1, name: "Shape Creation", isActive: true },
            { id: 2, name: "Brim", isActive: true },
            { id: 4, name: "Modification", isActive: true },
            { id: 5, name: "Angles", isActive: true },
            { id: 6, name: "Measurement Notes", isActive: true },
          ],
          formContent: (
            <TfMeasurement
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={4}
              currentIndex={2}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 3,
          name: "Product Information",
          innerSteps: [
            { id: 1, name: "Foam Carving", isActive: true },
            { id: 2, name: "Socket Material", isActive: true },
            { id: 3, name: "Suspension", isActive: true },
            { id: 4, name: "Mounting Plate", isActive: true },
            { id: 5, name: "Insert Material", isActive: true },
            { id: 6, name: "Delivery Date", isActive: true },
            { id: 7, name: "Notes", isActive: true },
          ],
          formContent: (
            <FoamCarving
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={4}
              currentIndex={3}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },
      ],
      name: "TF Check Socket",
    },

    {
      id: "5",
      url: "/ttdefinitive",
      formData: [
        {
          id: 1,
          name: "Patient Information",

          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={5}
              currentIndex={1}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 2,
          name: "Product Measurement",
          innerSteps: [
            { id: 1, name: "Socket Options", isActive: true },
            { id: 2, name: "Measurements", isActive: true },
            { id: 3, name: "Socket Material", isActive: true },
            { id: 4, name: "Insert Material", isActive: true },
            { id: 5, name: "RevoFit", isActive: true },
            { id: 6, name: "Suspension", isActive: true },
            { id: 7, name: "Mounting Plates", isActive: true },
            { id: 8, name: "Prosthetic Height", isActive: true },
            { id: 9, name: "Delivery Date", isActive: true },
            { id: 10, name: "Notes", isActive: true },
          ],
          formContent: (
            <TtMeasurement
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={5}
              currentIndex={2}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },
      ],
      name: "TT Definitive Socket",
    },

    {
      id: "6",
      url: "/tfdefinitive",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={6}
              currentIndex={1}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 2,
          name: "Product Measurement",
          innerSteps: [
            { id: 1, name: "Socket Options", isActive: true },
            { id: 2, name: "Measurements", isActive: true },
            { id: 3, name: "Socket Material", isActive: true },
            { id: 4, name: "Insert Material", isActive: true },
            { id: 5, name: "RevoFit", isActive: true },
            { id: 6, name: "Suspension", isActive: true },
            { id: 7, name: "Mounting Plates", isActive: true },
            { id: 8, name: "Prosthetic Height", isActive: true },
            { id: 9, name: "Delivery Date", isActive: true },
            { id: 10, name: "Notes", isActive: true },
          ],
          formContent: (
            <TFDefinitiveMeasurement
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={6}
              currentIndex={2}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },
      ],
      name: "TF Definitive Socket",
    },

    {
      id: "7",
      url: "/ttonesocket",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={7}
              currentIndex={1}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 2,
          name: "Product Measurement",
          innerSteps: [
            { id: 1, name: "Measurements", isActive: true },
            { id: 2, name: "One® System", isActive: true },
            { id: 3, name: "Socket Finish", isActive: true },
            { id: 4, name: "Socket Options", isActive: true },
            { id: 5, name: "Mounting Plate", isActive: true },
            { id: 6, name: "Prosthetic Height", isActive: true },
            { id: 7, name: "Delivery Date", isActive: true },
            { id: 7, name: "Notes", isActive: true },
          ],
          formContent: (
            <TTOneMeasure
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={7}
              currentIndex={2}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },
      ],
      name: "TT One® Socket",
    },

    {
      id: "8",
      url: "/tfonesocket",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              currentIndex={1}
              formTypeId={8}
              setIsBack={setIsBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },

        {
          id: 2,
          name: "Product Measurement",
          innerSteps: [
            { id: 1, name: "Measurements", isActive: true },
            { id: 2, name: "One® System", isActive: true },
            { id: 3, name: "Socket Finish", isActive: true },
            { id: 4, name: "Mounting Plate", isActive: true },
            { id: 5, name: "Prosthetic Height", isActive: true },
            { id: 6, name: "Delivery Date", isActive: true },
            { id: 7, name: "Notes", isActive: true },
          ],
          formContent: (
            <TFOneSocketMeasure
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={8}
              currentIndex={2}
              handleNext={handleNext}
              handleBack={handleBack}
              setIsBack={setIsBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
            />
          ),
        },
      ],
      name: "TF One® Socket",
    },
  ];

  const totalIds = currentComponent?.formData.reduce((count) => {
    return count + 1;
  }, 0);
  return (
    <div className="bilateral">
      <div style={{ display: "flex", gap: "4px", marginBottom: "2px" }}>
        {defaultComponent?.map((item, index) => (
          <div style={{ width: "100%", height: "56px" }} key={index}>
            <div
              className={`${
                currentFormIndex > index ? "biletralCompletion" : ""
              } bilateralHeader`}
              style={{
                background:
                  currentFormIndex === 2 &&
                  currentComponent.formData.length === activeOuterStep + 1
                    ? "var(--secondary-600)"
                    : currentFormIndex > index
                    ? "var(--secondary-600)"
                    : currentFormIndex === index
                    ? "#F3F3F3"
                    : "white",
                // borderBottom:
                //   currentFormIndex > index ? "2px solid black" : "transparent",
                color:
                  currentFormIndex === 2 &&
                  currentComponent.formData.length === activeOuterStep + 1
                    ? "white"
                    : currentFormIndex > index
                    ? "white"
                    : "",
              }}
            >
              {currentFormIndex > index ? (
                <div className="tickIcon">
                  <OrderTickIcon />
                </div>
              ) : (
                <></>
              )}
              {index === 2 &&
                currentComponent?.formData?.length === activeOuterStep + 1 && (
                  <div className="tickIcon">
                    <OrderTickIcon />
                  </div>
                )}
              {item?.name}
            </div>
            <div
              style={{
                background: "#008457",
                height: "2px",
                width:
                  currentComponent?.name === item?.name &&
                  index === currentFormIndex
                    ? `${
                        ((activeOuterStep + 1) /
                          currentComponent?.formData?.length) *
                        100
                      }%`
                    : currentFormIndex > index
                    ? "100%"
                    : "0px",
              }}
            ></div>
          </div>
        ))}
      </div>

      {currentComponent && (
        <BilateralStepper
          data={currentComponent.formData}
          innerStep={activeInnerStep}
          activeOuterStep={activeOuterStep}
          formName={currentComponent.name}
          totalSteps={totalIds}
        />
      )}
    </div>
  );
};

export default Bilateral;
